import React from 'react';

const Deals = () => {
  return (
    <div className="container text-center pt-5">
      <div className="display-4 pt-5 pb-3">Deals Page Comming Soon...</div>
      <h1>I am working very hard for makeing this website fully functional. Thanks for being with me.</h1>
    </div>
  );
};

export default Deals;